<template>
    <div>
        <header>
            <div class="container">
                <a href="https://brytonprinting.com/"><img src="img/header.jpg" alt=""></a>

            </div>
        </header>
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="main-section">
                        <h1 class="text-booklet text-center">Your Booklet & Catalog Printer</h1>
                        <h1 class="Quality-text">Exceptional Quality without Breaking the Bank!</h1>
                        <div class="f-img">
                            <img src="img/Woman with booklet Flattened.jpg" alt="">
                        </div>
                        <p class="Bryton-text-add">
                            At Bryton Printing, we bring your vision to life with unmatched printing expertise
                            built on 40 years of dedication to our craft. From short runs of 10 to large orders of up to
                            10,000, we are equipped to handle any project with state-of-the-art technology, friendly
                            service, and an unwavering commitment to quality.
                        </p>
                        <div class="galleryy">
                            <div>
                                <img src="img/Two-pictures-Side-by-Side1.png" alt="">
                            </div>

                            <div>
                                <img src="img/Two-pictures-Side-by-Side.png" alt="">
                            </div>
                        </div>
                        <div class="Printing-section">
                            <img src="img/Why Choose Bryton Printng.jpg" alt="">
                            <div class="cover">
                                <ul class="liststyle">
                                    <li>
                                        <p>
                                            <span style="background-color: #5d569b;">decades of experience</span> We've been the
                                            trusted choice for printing booklets, catalogs, and books. Our longevity
                                            speaks volumes about the quality and reliability we deliver. One happy customer shared,
                                            "Highly pleased with the speed and quality of the work.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <span style="background-color: #9c478f;">cutting-edge technology</span> Advanced Canon
                                            C810 press for smaller orders and the powerful RMGT 945 for larger
                                            volumes, your materials are produced with precision and clarity. As another customer
                                            noted, "Responsive, timely, professional, and knowledgeable.
                                        </p>
                                    </li>
                                    <li>

                                        <p>
                                            <span style="background-color: #de343b;">sustainability in printing</span> Concerned about
                                            what your printing is doing to the environment, you've come to the right
                                            place. At Bryton Printing.
                                        </p>
                                        <ul class="recycled-texts">
                                            <li>All our waste paper is recycled.</li>
                                            <li>All our aluminum plates are recycled.</li>
                                            <li>
                                                We use UV-cured ink, which is better for the environment because it doesn't emit
                                                harmful solvents with VOCs (Volatile Organic Compounds).
                                            </li>
                                            <li>Our computer-aided color control cuts waste by up to 50% while improving quality.</li>
                                            <li>
                                                Our solvents (press washes) contain 90% less VOCs than standard press washes. We're
                                                here to make sure that your job-no matter how simple or complicated-is delivered with
                                                little or no negative impact on the environment.
                                            </li>
                                        </ul>
                                    </li>
                                    <li>

                                        <p>
                                            <span style="background-color: #60a153;">customer-centric approach</span> Part of our
                                            success is our friendly, professional team,
                                            committed to making your printing experience seamless and stress-free. A delighted
                                            customer shared, "Went above and beyond to address my needs
                                        </p>
                                    </li>
                                    <li>

                                        <p>
                                            <span style="background-color: #55a9dc;">fair pricing & honest service</span> Customers
                                            value our transparent approach, with one mentioning, "Fair pricing and honest
                                            service."
                                        </p>
                                    </li>
                                </ul>
                                <p class="dependable-text">
                                    High-quality printing doesn't have to come with a hefty price tag. At
                                    Bryton Printing, we believe in offering premium results at/prices designed not to take a big
                                    bite out of your budget. Experience top-tier service that's as affordable as it is dependable.
                                </p>
                            </div>
                        </div>
                        <div class="get-section">
                            <img src="img/Let's Get Started.jpg" alt="">
                            <p>
                                Let's create something extraordinary together. Contact us today for a free quote and discover how
                                we can bring your ideas to life with unmatched quality, care, and environmental responsibility.
                            </p>
                            <div class="phone-images">
                                <div class="image-div"><img src="img/Woman with booklet Flattened.jpg" alt=""></div>
                                <div class="image-div">
                                    <button>Get Free Quote</button>
                                    <b><a href="tel:+17149934800">714-993-4800</a></b>
                                </div>
                            </div>
                        </div>
                        <div class="about-section">
                            <img src="img/More About Us.jpg" alt="">
                            <div class="abt-text">
                                <p>
                                    At Bryton Printing, we specialize in high-quality, custom catalog printing services tailored to
                                    your business needs. Whether you're looking for 10 printing for a specific event or 10,000
                                    large-scale commercial printing, we're committed to delivering visually stunning and durable
                                    catalogs. With options for digital and offset printing, our catalogs are crafted with vibrant
                                    color
                                    accuracy and premium materials, making each page come alive with your products and services.
                                </p>
                                <p>
                                    Our services include a variety of catalog sizes, finishes, and binding options, allowing you to
                                    create catalogs that are as unique as your brand. Choose from popular options like
                                    saddle-stitching, perfect binding or wire-O binding, available in both matte and glossy
                                    finishes.
                                    Plus, with eco-friendly options and fast turnaround times, we ensure your catalogs are not only
                                    high-quality but also meet your timeline and sustainability goals.
                                </p>
                                <p>
                                    Contact Bryton Printing today to learn how our catalog printing can enhance your brand presence,
                                    attract new customers, and drive sales.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div>
                        <Form style="background-color: #F5F5F5 !important;" autocomplete="off" @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }" class="form-area" id="quoteForm">
                            <h2>Get a Free Custom Quote:</h2>
                            <div class="mb-3">
                                <label>
                                    Fill out your project details below - our team will review everything and follow up with a personalized quote, built to match your needs and budget.
                                    <!--We handle everything from small, simple orders to large, complex productions, always delivering exceptional quality at fair, honest prices.
                                    (No instant quotes - we make sure every estimate matches your exact project.)-->
                                    <br /> <br />
                                    Need help sooner? Call <a href="tel:714-993-4800" style="color: #6c549d; font-weight: 700;">714-993-4800</a>.
                                    or email <a href="mailto:Jeff@BrytonPrinting.com" style="color: #6c549d; font-weight: 700;">Jeff@BrytonPrinting.com</a>.
                                </label>
                            </div>
                            <h3>Project Details:</h3>

                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label d-block">
                                    <b> Finished Size (check one or fill custom):</b>
                                </label>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="inlineCheckbox1" name="FinishedSize" value="5.5 x 8.5" v-model="bookletdata.FinishedSize" @change="FinishedSizeChange" />
                                    <label class="form-check-label" for="inlineCheckbox1">5.5" x 8.5"</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="inlineCheckbox2" name="FinishedSize" value="6 x 9" v-model="bookletdata.FinishedSize" @change="FinishedSizeChange" />
                                    <label class="form-check-label" for="inlineCheckbox2">6" x 9"</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="inlineCheckbox2" name="FinishedSize" value="8 x 11" v-model="bookletdata.FinishedSize" @change="FinishedSizeChange" />
                                    <label class="form-check-label" for="inlineCheckbox2">8" x 11"</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="inlineCheckbox2" name="FinishedSize" value="Custom" v-model="bookletdata.FinishedSize" @change="FinishedSizeChange" />
                                    <label class="form-check-label" for="inlineCheckbox2">Custom</label>

                                </div>
                                <div v-if="FinishedSizeCheck">
                                    <Field type="number" name="Fwidth" v-model="bookletdata.Fwidth" @change="hidErrorMessage"></Field> X  <Field type="number" name="Fhight" v-model="bookletdata.Fhight" @change="hidErrorMessage"></Field>
                                    <div style="color:red;">{{errors.Fwidth}}</div>
                                    <div style="color:red;">{{errors.Fhight}}</div>
                                </div>
                                <div style="color:red;">{{errors.FinishedSize}}</div>
                            </div>
                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label d-block">
                                    <b>Orientation :</b>
                                </label>
                                <div class="form-check">
                                    <Field class="form-check-input" type="radio" name="Orientation" value="Tall" v-model="bookletdata.Orientation" id="Tall" @change="CheckOrientationQuantity" />
                                    <label class="form-check-label" for="Tall">
                                        Tall (Portrait binding on long edge)
                                    </label>
                                </div>
                                <div class="form-check">
                                    <Field class="form-check-input" type="radio" name="Orientation" value="Wide" v-model="bookletdata.Orientation" id="Wide" @change="CheckOrientationQuantity" />
                                    <label class="form-check-label" for="Wide">
                                        Wide (Landscape/Album - binding on short edge) for quantities greater than 500
                                    </label>
                                </div>
                                <div style="color:red;">{{errors.Orientation}}</div>
                            </div>
                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label"><b>Quantity (10 to 10,000)</b></label>
                                <Field type="number" name="quantity" v-model="bookletdata.quantity" class="form-control" aria-describedby="emailHelp" @change="hidErrorMessage" />
                                <div style="color:red;">{{errors.quantity}}</div>
                            </div>
                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label d-block">
                                    <b> Paper Type (check one):</b>
                                </label>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Gloss" name="PaperType" value="Gloss" v-model="bookletdata.PaperType" @change="PaperWightChange" />
                                    <label class="form-check-label" for="Gloss">Gloss</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Silk" name="PaperType" value="Silk" v-model="bookletdata.PaperType" @change="PaperWightChange" />
                                    <label class="form-check-label" for="Silk">Silk (dull / matte) </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Uncoated" name="PaperType" value="Uncoated" v-model="bookletdata.PaperType" @change="PaperWightChange" />
                                    <label class="form-check-label" for="Uncoated">Uncoated</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Other" name="PaperType" value="Other" v-model="bookletdata.PaperType" @change="PaperWightChange" />
                                    <label class="form-check-label" for="Other">Other</label>
                                </div>
                                <div v-if="bookletdata.PaperType=='Other'">
                                    <Field type="text" class="form-control" placeholder="Enter Paper Type" name="PaperTypeOther" v-model="bookletdata.PaperTypeOther" @change="hidErrorMessage"></Field>
                                </div>
                                <div style="color:red;">{{errors.PaperTypeOther}}</div>
                                <div style="color:red;">{{errors.PaperType}}</div>
                            </div>
                            <div v-if="PaperWeightCheck=='Gloss' && bookletdata.PaperType!='Other'" class="mb-3">
                                <label for="exampleInputEmail1" class="form-label d-block">
                                    <b> Paper Weight (thickness):</b>
                                </label>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="70lb" name="PaperWeight" value="70" v-model="bookletdata.PaperWeight" @change="PaperWightOnChange" />
                                    <label class="form-check-label" for="50lb">70 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="80lb" name="PaperWeight" value="80" v-model="bookletdata.PaperWeight" @change="PaperWightOnChange" />
                                    <label class="form-check-label" for="50lb">80 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="100lb" name="PaperWeight" value="100" v-model="bookletdata.PaperWeight" @change="PaperWightOnChange" />
                                    <label class="form-check-label" for="70lb">100 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="other" name="PaperWeight" value="Other" v-model="bookletdata.PaperWeight" @change="PaperWightOnChange" />
                                    <label class="form-check-label" for="other">Other</label>
                                </div>
                                <div v-if="bookletdata.PaperWeight=='Other'">
                                    <Field type="number" class="form-control" name="PaperWeightother" v-model="bookletdata.PaperWeightother" @change="hidErrorMessage"></Field> lb
                                </div>
                                <div style="color:red;">{{errors.PaperWeightother}}</div>
                                <div style="color:red;">{{errors.PaperWeight}}</div>
                            </div>
                            <div v-if="PaperWeightCheck=='Uncoated' && bookletdata.PaperType!='Other'" class="mb-3">
                                <label for="exampleInputEmail1" class="form-label d-block">
                                    <b> Paper Weight (thickness):</b>
                                </label>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Coated50lb" name="PaperWeight" value="50" v-model="bookletdata.PaperWeight" @change="PaperWightOnChange" />
                                    <label class="form-check-label" for="Coated50lb">50 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Coated60lb" name="PaperWeight" value="60" v-model="bookletdata.PaperWeight" @change="PaperWightOnChange" />
                                    <label class="form-check-label" for="Coated60lb">60 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Coated701lb" name="PaperWeight" value="70" v-model="bookletdata.PaperWeight" @change="PaperWightOnChange" />
                                    <label class="form-check-label" for="Coated701lb">70 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Coated80lb" name="PaperWeight" value="80" v-model="bookletdata.PaperWeight" @change="PaperWightOnChange" />
                                    <label class="form-check-label" for="Coated80lb">80 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Coatedotherlb" name="PaperWeight" value="Other" v-model="bookletdata.PaperWeight" @change="PaperWightOnChange" />
                                    <label class="form-check-label" for="Coatedotherlb">Other</label>
                                </div>
                                <div v-if="bookletdata.PaperWeight=='Other'">
                                    <Field type="number" class="form-control" name="PaperWeightother" v-model="bookletdata.PaperWeightother" @change="hidErrorMessage"></Field> lb
                                </div>
                                <div style="color:red;">{{errors.PaperWeightother}}</div>
                                <div style="color:red;">{{errors.PaperWeight}}</div>
                            </div>
                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label d-block">
                                    <b>Cover Paper :</b>
                                </label>
                                <div class="form-check">
                                    <Field class="form-check-input" type="radio" name="Cover" v-model="bookletdata.Cover" value="Same as inside" id="self-cover" @change="CoverOnChange" />
                                    <label class="form-check-label" for="self-cover">
                                        Same as inside (self cover)
                                    </label>
                                </div>
                                <div class="form-check">
                                    <Field class="form-check-input" type="radio" name="Cover" v-model="bookletdata.Cover" value="Heavier cover" id="plus-cover" @change="CoverOnChange" />
                                    <label class="form-check-label" for="plus-cover">
                                        Heavier cover (plus cover)
                                    </label>
                                </div>
                                <div style="color:red;">{{errors.Cover}}</div>
                            </div>
                            <div v-if="bookletdata.Cover=='Heavier cover'" class="mb-3">
                                <label for="exampleInputEmail1" class="form-label d-block">
                                    <b> Cover Stock (If different than the inside)</b>
                                </label>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Gloss" name="CoverStock" value="Gloss" v-model="bookletdata.CoverStock" @change="CoverStockChange" />
                                    <label class="form-check-label" for="Gloss">Gloss</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Silk" name="CoverStock" value="Silk" v-model="bookletdata.CoverStock" @change="CoverStockChange" />
                                    <label class="form-check-label" for="Silk">Silk (dull / matte) </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Uncoated" name="CoverStock" value="Uncoated" v-model="bookletdata.CoverStock" @change="CoverStockChange" />
                                    <label class="form-check-label" for="Uncoated">Uncoated</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Other" name="CoverStock" value="StockOther" v-model="bookletdata.CoverStock" @change="CoverStockChange" />
                                    <label class="form-check-label" for="Other">Other</label>
                                </div>
                                <div v-if="bookletdata.CoverStock=='StockOther'">
                                    <Field type="text" class="form-control" placeholder="Enter Cover Stock" name="CoverStockOther" v-model="bookletdata.CoverStockOther" @change="hidErrorMessage"></Field>
                                </div>
                                <div style="color:red;">{{errors.CoverStockOther}}</div>
                                <div style="color:red;">{{errors.CoverStock}}</div>
                            </div>
                            <div v-if="bookletdata.Cover=='Heavier cover'" class="mb-3">
                                <label for="exampleInputEmail1" class="form-label d-block">
                                    <b> Cover Paper Weight (Thickness)</b>
                                </label>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="65lb" name="CoverPaperWeight" value="65" v-model="bookletdata.CoverPaperWeight" @change="CoverPaperOnChange" />
                                    <label class="form-check-label" for="65lb">65 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="C80lb" name="CoverPaperWeight" value="80" v-model="bookletdata.CoverPaperWeight" @change="CoverPaperOnChange" />
                                    <label class="form-check-label" for="C80lb">80 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="C100lb" name="CoverPaperWeight" value="100" v-model="bookletdata.CoverPaperWeight" @change="CoverPaperOnChange" />
                                    <label class="form-check-label" for="C100lb">100 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="C110lb" name="CoverPaperWeight" value="110" v-model="bookletdata.CoverPaperWeight" @change="CoverPaperOnChange" />
                                    <label class="form-check-label" for="C110lb">110 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="C120lb" name="CoverPaperWeight" value="120" v-model="bookletdata.CoverPaperWeight" @change="CoverPaperOnChange" />
                                    <label class="form-check-label" for="C120lb">120 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="C130lb" name="CoverPaperWeight" value="130" v-model="bookletdata.CoverPaperWeight" @change="CoverPaperOnChange" />
                                    <label class="form-check-label" for="C130lb">130 lb</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" id="Cother" name="CoverPaperWeight" value="CoverPaperOther" v-model="bookletdata.CoverPaperWeight" @change="CoverPaperOnChange" />
                                    <label class="form-check-label" for="Cother">Other</label>
                                </div>
                                <div v-if="bookletdata.CoverPaperWeight=='CoverPaperOther'">
                                    <Field type="number" class="form-control" name="CoverPaperWeightother" v-model="bookletdata.CoverPaperWeightother" @change="hidErrorMessage"></Field> lb
                                </div>
                                <div style="color:red;">{{errors.CoverPaperWeightother}}</div>
                                <div style="color:red;">{{errors.CoverPaperWeight}}</div>
                            </div>
                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label d-block">
                                    <b>Binding Option:</b>
                                </label>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" name="BindingOption" v-model="bookletdata.BindingOption" value="Saddle Stitched" id="Saddle" @change="BindingOnChange" />
                                    <label class="form-check-label" for="Saddle">
                                        Saddle Stitched (Like a magazine)
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" name="BindingOption" v-model="bookletdata.BindingOption" value="Perfect Bound" id="PerfectBound" @change="BindingOnChange" />
                                    <label class="form-check-label" for="PerfectBound">
                                        Perfect Bound (like a paper back book)
                                    </label>
                                </div>

                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" name="BindingOption" v-model="bookletdata.BindingOption" value="Plastic Coil" id="PlasticCoil" @change="BindingOnChange" />
                                    <label class="form-check-label" for="PlasticCoil">
                                        Plastic Coil
                                    </label>
                                </div>

                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" name="BindingOption" v-model="bookletdata.BindingOption" value="Wire O" id="Wire" @change="BindingOnChange" />
                                    <label class="form-check-label" for="Wire">
                                        Wire-O
                                    </label>
                                </div>

                                <div class="form-check form-check-inline">
                                    <Field class="form-check-input" type="radio" name="BindingOption" v-model="bookletdata.BindingOption" value="bindingOther" id="bindingOther" @change="BindingOnChange" />
                                    <label class="form-check-label" for="bindingOther">
                                        Other
                                    </label>
                                </div>
                                <div v-if="bookletdata.BindingOption=='bindingOther'">
                                    <Field type="text" class="form-control" placeholder="Enter Binding" name="OptionbindingOther" maxlength="200" v-model="bookletdata.OptionbindingOther" @change="hidErrorMessage"></Field>
                                </div>
                                <div style="color:red;">{{errors.OptionbindingOther}}</div>
                                <div style="color:red;">{{errors.BindingOption}}</div>

                            </div>
                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label"><b>Number of Pages</b></label>
                                <Field type="number" id="txtNumberOfPages" name="PageSize" v-model="bookletdata.PageSize" class="form-control" @change="BindingOnChange" />
                                <div id="dvNumberOfPages" style="color:red;"></div> <!--{{errors.PageSize}}-->

                            </div>
                            <div id="timeline" class="mb-3 mt-2">
                                <label for="timeline" class="form-label">
                                    <b>Timeline</b> When do you need
                                    it by?:

                                </label>


                                <Field v-model="bookletdata.Dates"
                                       name="Dates"
                                       value="value">
                                    <Calendar v-model="bookletdata.Dates" placeholder="Choose Date" />
                                </Field>
                                <!--<Field type="text" name="Dates" v-model="bookletdata.Dates" class="form-control" id="name" placeholder="Enter Date" />-->
                                <div style="color:red;">{{errors.Dates}}</div>
                            </div>
                            <div class="mb-3">
                                <label>
                                    <b>
                                        Notes and Additional Information
                                    </b>
                                </label>
                                <div class="form-floating">
                                    <Field as="textarea" class="form-control" maxlength="500" placeholder="Comments" name="comments" v-model="bookletdata.comments"
                                           style="height: 100px"></Field>
                                    <!--<label for="floatingTextarea2">Comments</label>-->
                                    <div style="color:red;">{{errors.comments}}</div>
                                </div>
                            </div>

                            <h6>Please Tell us about yourself</h6>We will never pass your information to another company.<br><br>
                            <div class="mb-3">
                                <Field type="text" class="form-control" name="FirstName" v-model="bookletdata.FirstName" id="name" placeholder="Enter Name" @change="hidErrorMessage" />
                                <div style="color:red;">{{errors.FirstName}}</div>
                            </div>

                            <div class="mb-3">
                                <Field v-slot="{field }"
                                       v-model="bookletdata.phoneNumber"
                                       name="phoneNumber"
                                       value="value" @change="hidErrorMessage">
                                    <input-mask name="phoneNumber"
                                                v-model="bookletdata.phoneNumber"
                                                :model-value="field.value"
                                                mask="(999) 999-9999"
                                                placeholder="Enter phone number"
                                                @blur="validatePhoneNumber"
                                                class="form-control mb-1"
                                                type="text"></input-mask>
                                    <div style="color:red;">{{errors.phoneNumber}}</div>
                                </Field>
                                <!--<Field type="number" class="form-control" name="phoneNumber" v-model="bookletdata.phoneNumber" id="exampleFormControlInput1" placeholder="Phone Number" />
                                <div style="color:red;">{{errors.phoneNumber}}</div>-->
                            </div>
                            <div class="mb-3">
                                <Field type="email" class="form-control" name="email" v-model="bookletdata.email" id="exampleFormControlInput1" placeholder="Email" @change="hidErrorMessage" />
                                <div style="color:red;">{{errors.email}}</div>
                            </div>

                            <button v-if="btnDisabled" @click="myCFunction" type="submit" class="btn btn-primary submit-btt">Get My Free Quote</button>
                            <div id="myDiv" style="color:red;display:none;">Some fields(s) need your attention above.</div>
                        </Form>
                    </div>
                </div>
                <footer class="contact-footer">
                    <div class="footer-top">
                        <div class="footer-logo-section">
                            <p>&copy;2012-2025 Bryton Printing, All Rights Reserved.</p>
                        </div>
                        <div class="footer-details">
                            <div class="personal-info">
                                <h3>Contact</h3>
                                <p>Jeff Weston</p>
                                <p>
                                    <a href="tel:714-993-4000">
                                        714-993-4000
                                    </a>
                                </p>
                                <p>
                                    <a href="mailto:Jeff@BrytonPrinting.com">
                                        Jeff@BrytonPrinting.com
                                    </a>
                                </p>
                            </div>
                            <div class="company-info">
                                <h3>Bryton Printing</h3>
                                <p>3345 E. Miraloma Ave. Unit 134</p>
                                <p>Anaheim, CA 92806</p>
                                <p><a href="https://www.google.com/maps/place/Bryton+Printing/@33.860848,-117.850989,16z/data=!4m6!3m5!1s0x80dcd6bec20ebb37:0xd6287fcb4956d260!8m2!3d33.860848!4d-117.8509893!16s%2Fg%2F12jvys7bx?hl=en&entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoASAFQAw%3D%3D">Map / Directions</a></p>
                            </div>
                        </div>
                    </div>

                </footer>
                <div class="footer-section">
                    <div class="footer-left">
                        <img src="img/footer-logo1.jpg" alt="">
                    </div>
                    <div class="footer-right">
                        <div class="personal-info">
                            <h3>Contact</h3>
                            <p>Jeff Weston</p>
                            <p>
                                <a href="tel:714-993-4000">
                                    714-993-4000
                                </a>
                            </p>
                            <p>
                                <a href="mailto:Jeff@BrytonPrinting.com">
                                    Jeff@BrytonPrinting.com
                                </a>
                            </p>
                        </div>
                        <div class="company-info">
                            <h3>Address</h3>
                            <p>Bryton Printing</p>
                            <p>3345 E. Miraloma Ave. Unit 134</p>
                            <p>Anaheim, CA 92806</p>
                            <p>
                                <a href="https://www.google.com/maps/place/Bryton+Printing/@33.860848,-117.850989,16z/data=!4m6!3m5!1s0x80dcd6bec20ebb37:0xd6287fcb4956d260!8m2!3d33.860848!4d-117.8509893!16s%2Fg%2F12jvys7bx?hl=en&entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoASAFQAw%3D%3D">
                                    Map
                                    / Directions
                                </a>
                            </p>
                        </div>
                    </div>
                    <div class="cr-text">
                        <p>&copy;2012-2025 Bryton Printing, All Rights Reserved.</p>
                    </div>
                </div>
                <!--<footer class="mobile">
                    <div class="footer-logo">
                        <img src="img/footer-logo.jpg" alt="">
                    </div>
                    <div class="footer-links">
                        <div class="personal-info">
                            <h3>Contact</h3>
                            <p>Jeff Weston</p>
                            <p>
                                <a href="tel:714-993-4000">
                                    714-993-4000
                                </a>
                            </p>
                            <p>
                                <a href="mailto:Jeff@BrytonPrinting.com">
                                    Jeff@BrytonPrinting.com
                                </a>
                            </p>
                        </div>
                        <div class="company-info">
                            <h3>Address</h3>
                            <p>Bryton Printing</p>
                            <p>3345 E. Miraloma Ave. Unit 134</p>
                            <p>Anaheim, CA 92806</p>
                            <p><a href="#">Map / Directions</a></p>
                        </div>
                        <div class="copyright">
                            &copy;2012-2025 Bryton Printing, All Rights Reserved.
                        </div>
                    </div>

                </footer>-->
            </div>
        </div>

    </div>
</template>

<script>
    //import { createApp } from 'vue';
    //import App from '@/App.vue';

    //const app = createApp(App);

    //app.mount('#app');

    //// Remove loader
    //window.addEventListener('DOMContentLoaded', () => {
    //    const loader = document.getElementById('app-loader');
    //    if (loader) {
    //        loader.parentNode.removeChild(loader);
    //    }
    //});


    import { Form, Field } from 'vee-validate';
    import * as Yup from 'yup';
    import BookletService from '@/Services/BookletService';
    import Calendar from 'primevue/calendar';
    import InputMask from '@/views/shared/inputmask/inputmasktemplate.vue';
    //import { resolve } from 'core-js/library/fn/promise';
    export default {
        name: 'Booklet-Catalog-Book-Printing',
        components: {
            Form, Field, Calendar, InputMask
        },
        mounted() {
            //const extDiv = document.getElementById('app-loader')
            //if (extDiv) {
            //    // Option 1: Hide it
            //    extDiv.style.display = 'none'

            //    // Option 2: Or completely remove it
            //    // extDiv.remove()
            //}
            document.title = 'Booklet & Catalog Printing in Anaheim | Bryton Printing';

            let metaDescription = document.querySelector('meta[name="description"]');
            if (!metaDescription) {
                metaDescription = document.createElement('meta');
                metaDescription.name = 'description';
                document.head.appendChild(metaDescription);
            }
            metaDescription.content = 'Affordable, high-quality catalog and booklet printing in Anaheim & Orange County. Fast turnaround, expert service, free quotes.';
        },
        data() {
            const schemaObject = {
                FirstName: Yup.string().required('Name is required.'),
                email: Yup.string().required('Email is required.').email('Email is invalid.').matches('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', 'Email is invalid.'),
                phoneNumber: Yup.string().required('Phone is required.'), //.matches(/^\d{10}$/, 'Phone number should be of 10 digits.'),
                quantity: Yup.number().typeError('Quantity is required.').min(10, 'Quantity should be 10 or greater.'),
                //.max(10000, 'Maximum quantity is 10,000'),
                FinishedSize: Yup.string().required('Finished Size is required.'),
                BindingOption: Yup.string().required('Binding Option is required.'),
                Cover: Yup.string().required('Cover is required.'),
                PaperWeight: Yup.string().required('Paper Weight is required.'),
                PaperType: Yup.string().required('Paper Type is required.'),
                PageSize: Yup.number().typeError('Number of Pages are required.').min(8, 'Number of pages are too few.'),
                // .max(1000, 'Maximum Pages are 1000.'),
                Orientation: Yup.string().required('Orientation is required.'),
                // Dates: Yup.string().required('Timeline is required.'),
                //  comments: Yup.string().required('Notes are required.'),
                Fwidth: Yup.number().typeError('Quantity is required.').min(1, 'Finished Size is 10')
                    .max(100, 'Finished Size is 100'),
                Fhight: Yup.number().typeError('Quantity is required.').min(1, 'Finished Size is 10')
                    .max(100, 'Finished Size is 100'),
            }
            let schema = Yup.object().shape(schemaObject);
            return {
                schema, schemaObject, FinishedSizeCheck: false, PaperWeightCheck: 'Gloss', btnDisabled: true,
                bookletdata: {
                    FirstName: '',
                    phoneNumber: '',
                    email: '',
                    quantity: '',
                    FinishedSize: '8 x 11',
                    Dates: '',
                    BindingOption: 'Saddle Stitched',
                    Cover: 'Same as inside',
                    PaperWeight: '100',
                    PaperType: 'Gloss',
                    PageSize: '',
                    Orientation: 'Tall',
                    comments: '',
                    Fwidth: '',
                    Fhight: '',
                    PaperWeightother: '',
                    FinishedSizeother: '',
                    OptionbindingOther: '',
                    CoverStockOther: '',
                    CoverStock: '',
                    CoverPaperWeightother: '',
                    CoverPaperWeight: ''

                }
            }

        },
        methods: {
            async hidErrorMessage() {
                document.getElementById('dvNumberOfPages').innerHTML = '';
                const div = document.getElementById("myDiv");
                div.style.display = "none";
            },
            async myCFunction() {
                
                this.hidErrorMessage();
                this.checkNumberOfPages();

                try {
                    const schemaObject = {
                        FirstName: Yup.string().required('Name is required.'),
                        email: Yup.string().required('Email is required.').email('Email is invalid.').matches('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', 'Email is invalid.'),
                        phoneNumber: Yup.string().required('Phone is required.'), //.matches(/^\d{10}$/, 'Phone number should be of 10 digits.'),
                        quantity: Yup.number().typeError('Quantity is required.').min(10, 'Quantity should be 10 or greater.'),
                        //.max(10000, 'Maximum quantity is 10,000'),
                        FinishedSize: Yup.string().required('Finished Size is required.'),
                        BindingOption: Yup.string().required('Binding Option is required.'),
                        Cover: Yup.string().required('Cover is required.'),
                        PaperWeight: Yup.string().required('Paper Weight is required.'),
                        PaperType: Yup.string().required('Paper Type is required.'),
                        PageSize: Yup.number().typeError('Number of Pages are required.').min(8, 'Number of pages are too few.'),
                        // .max(1000, 'Maximum Pages are 1000.'),
                        Orientation: Yup.string().required('Orientation is required.'),
                        // Dates: Yup.string().required('Timeline is required.'),
                        //  comments: Yup.string().required('Notes are required.'),
                        Fwidth: Yup.number().typeError('Quantity is required.').min(1, 'Finished Size is 10')
                            .max(100, 'Finished Size is 100'),
                        Fhight: Yup.number().typeError('Quantity is required.').min(1, 'Finished Size is 10')
                            .max(100, 'Finished Size is 100'),
                    }
                    let schema = Yup.object().shape(schemaObject);


                    await schema.validate(this.form, { abortEarly: false });
                    this.errors = [];
                    // alert('Form is valid!');
                    const div = document.getElementById("myDiv");
                    div.style.display = "none";
                } catch (err) {
                    if (err.name === 'ValidationError') {
                        this.errors = err.errors;
                        // alert(err.errors);
                        const div = document.getElementById("myDiv");
                        div.style.display = "block";
                    }
                }
            },
            async checkNumberOfPages() {
                this.hidErrorMessage();
                const input = document.getElementById('txtNumberOfPages');
                const value = input.value;
                if (value == "" || value == null) {
                    document.getElementById('dvNumberOfPages').innerHTML = 'Number of Pages are required.';
                    // document.getElementById('txtNumberOfPages').focus();
                }
                else {
                    let num = Number(value);

                    if (num < 8) {
                        document.getElementById('dvNumberOfPages').innerHTML = 'Number of pages are too few.';
                        // document.getElementById('txtNumberOfPages').focus();
                    }
                    else {
                        const radio = document.getElementById('Saddle');
                        if (radio.checked) {
                            if (num % 4 === 0) {
                                this.hidErrorMessage();
                            } else {
                                document.getElementById('dvNumberOfPages').innerHTML = 'Saddle-stitched booklets must be in multiples of 4 pages. Please feel free to call if you have any questions: 714-993-4800.';
                                //  document.getElementById('txtNumberOfPages').focus();
                            }
                        } else {
                            if (num % 2 === 0) {
                                this.hidErrorMessage();
                            } else {
                                document.getElementById('dvNumberOfPages').innerHTML = 'For this binding method the number of pages must be in multiples of 2 pages. Please feel free to call if you have any questions: 714-993-4800.';
                                // document.getElementById('txtNumberOfPages').focus();
                            }
                        }
                    }
                }
            },
            async onSubmit() {
                const div = document.getElementById("myDiv");
                div.style.display = "none";
                this.btnDisabled = false;
                console.log('tt', this.bookletdata);
                let CustomeFinishedSize = '';
                if (this.bookletdata.Fwidth != '') {
                    CustomeFinishedSize = this.bookletdata.Fwidth + ' X ' + this.bookletdata.Fhight
                }

                var saveBookletData = {
                    Quantity: this.bookletdata.quantity,
                    OrientationType: this.bookletdata.Orientation,
                    NumberofPages: this.bookletdata.PageSize,
                    PaperType: this.bookletdata.PaperType != 'Other' ? this.bookletdata.PaperType : this.bookletdata.PaperTypeOther,
                    PaperWeight: this.bookletdata.PaperWeight != 'Other' ? this.bookletdata.PaperWeight : this.bookletdata.PaperWeightother,
                    CoverPaper: this.bookletdata.Cover,
                    BindingOption: this.bookletdata.BindingOption != 'bindingOther' ? this.bookletdata.BindingOption : this.bookletdata.OptionbindingOther,
                    TimelineDate: this.bookletdata.Dates.toString(),
                    Comments: this.bookletdata.comments,
                    Name: this.bookletdata.FirstName,
                    PhoneNumber: this.bookletdata.phoneNumber,
                    Email: this.bookletdata.email,
                    FinishedSize: this.bookletdata.FinishedSize != 'Custom' ? this.bookletdata.FinishedSize : CustomeFinishedSize,
                    CoverStock: this.bookletdata.CoverStock != 'StockOther' ? this.bookletdata.CoverStock : this.bookletdata.CoverStockOther,
                    CoverPaperWeight: this.bookletdata.CoverPaperWeight != 'CoverPaperOther' ? this.bookletdata.CoverPaperWeight : this.bookletdata.CoverPaperWeightother,
                };
                //console.log('tttttt', saveBookletData);
                BookletService.SaveBookletDetails(saveBookletData).then((response) => {
                    // console.log('response', response);
                    //alert(response.data.statusCode);
                    //alert(response.data.responseMessage);
                    if (response.status == 200) {
                        if (response.data.statusCode == 200) {
                            //this.$toast.success('Project Details has been submitted successfully!');
                            //setTimeout(() => { window.location.reload(); }, 6000)
                            //alert('Thank you for your submission. We will get back to you with an estimation shortly.');
                            //window.location.reload();
                             this.$router.push('/thanks');
                            //window.location.href = "https://brytonprinting.com/thanks";
                        }
                        else {
                            // alert('Error Ok');
                            this.$toast.error(response.data.responseMessage);
                            this.btnDisabled = true;
                        }
                    }
                    else {
                        this.$toast.error("Something went wrong. Please try again!!");
                        this.btnDisabled = true;
                    }
                });
            },
            CheckOrientationQuantity() {
                if (this.bookletdata.Orientation == 'Tall') {
                    this.schemaObject['quantity'] = Yup.number().typeError('Quantity is required.').min(10, 'Quantity should be 10 or greater.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                else {
                    this.schemaObject['quantity'] = Yup.number().typeError('Quantity is required.').min(500, 'For Wide (Album Style) booklets, the minimum is 500.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
            },
            FinishedSizeChange() {
                this.bookletdata.Fwidth = '',
                    this.bookletdata.Fhight = '';
                this.bookletdata.FinishedSizeother = '';
                if (this.bookletdata.FinishedSize == 'Custom') {
                    this.FinishedSizeCheck = true;
                    this.bookletdata.FinishedSizeother = (this.bookletdata.Fwidth + 'X' + this.bookletdata.Fhight)
                    this.schemaObject['Fwidth'] = Yup.number().typeError('Quantity is required.').min(1, 'Finished Size is 10')
                        .max(100, 'Finished Size is 100');
                    this.schemaObject['Fhight'] = Yup.number().typeError('Quantity is required.').min(1, 'Finished Size is 10')
                        .max(100, 'Finished Size is 100');
                    this.schemaObject['FinishedSize'] = Yup.string().nullable().notRequired();
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                else {
                    this.FinishedSizeCheck = false;
                    this.schemaObject['Fwidth'] = Yup.string().nullable().notRequired();
                    this.schemaObject['Fhight'] = Yup.string().nullable().notRequired();
                    this.schemaObject['FinishedSize'] = Yup.string().nullable().required('Finished Size is required.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
            },
            PaperWightChange() {
                this.bookletdata.PaperWeight = '';
                this.bookletdata.PaperTypeOther = '';
                if (this.bookletdata.PaperType == 'Uncoated') {
                    this.PaperWeightCheck = 'Uncoated';
                    this.schemaObject['PaperType'] = Yup.string().nullable().required('Paper Type is required.');
                    this.schemaObject['PaperWeight'] = Yup.string().required('Paper Weight is required.');
                    this.schemaObject['PaperWeightother'] = Yup.string().nullable().notRequired();
                    this.schemaObject['PaperTypeOther'] = Yup.string().nullable().notRequired();
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                else if (this.bookletdata.PaperType == 'Other') {
                    this.schemaObject['PaperType'] = Yup.string().nullable().notRequired();
                    this.schemaObject['PaperWeight'] = Yup.string().nullable().notRequired();
                    this.schemaObject['PaperWeightother'] = Yup.string().nullable().notRequired();
                    this.schemaObject['PaperTypeOther'] = Yup.string().nullable().required('Paper Type is required.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                else {
                    this.PaperWeightCheck = 'Gloss';
                    this.schemaObject['PaperType'] = Yup.string().nullable().required('Paper Type is required.');
                    this.schemaObject['PaperWeight'] = Yup.string().nullable().required('Paper Weight is required.');
                    this.schemaObject['PaperWeightother'] = Yup.string().nullable().notRequired();
                    this.schemaObject['PaperTypeOther'] = Yup.string().nullable().notRequired();
                    this.schema = Yup.object().shape(this.schemaObject);
                }
            },
            PaperWightOnChange() {
                this.bookletdata.PaperWeightother = '';
                if (this.bookletdata.PaperWeight == 'Other') {
                    this.schemaObject['PaperWeight'] = Yup.string().nullable().notRequired();
                    this.schemaObject['PaperWeightother'] = Yup.number().typeError('Paper Weight is required.').min(1, 'Minimum Paper Weight is 1 lb')
                        .max(500, 'Maximum Paper Weight is 500 lb');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                else {
                    this.schemaObject['PaperWeight'] = Yup.string().required('Paper Weight is required.');
                    this.schemaObject['PaperWeightother'] = Yup.string().nullable().notRequired();
                    this.schema = Yup.object().shape(this.schemaObject);
                }
            },
            BindingOnChange() {
                this.hidErrorMessage();
                this.checkNumberOfPages();

                // this.myCFunction();
                this.bookletdata.OptionbindingOther = '';
                if (this.bookletdata.BindingOption == 'bindingOther') {
                    this.schemaObject['PageSize'] = Yup.number().typeError('Number of Pages are required.').min(8, 'Number of pages are too few.');
                    this.schemaObject['BindingOption'] = Yup.string().nullable().notRequired();
                    this.schemaObject['OptionbindingOther'] = Yup.string().nullable().required('Binding Option is required.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                else if (this.bookletdata.BindingOption == 'Saddle Stitched') {
                    this.schemaObject['PageSize'] = Yup.number().typeError('Number of Pages are required.').min(8, 'Number of pages are too few.').test('divisibleByFour', 'Saddle-stitched booklets must be in multiples of 4 pages. Please feel free to call if you have any questions: 714-993-4800.', (value) => value % 4 === 0);
                    this.schemaObject['OptionbindingOther'] = Yup.string().nullable().notRequired();
                    this.schemaObject['BindingOption'] = Yup.string().nullable().required('Binding Option is required.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                else {
                    this.schemaObject['PageSize'] = Yup.number().typeError('Number of Pages are required.').min(8, 'Number of pages are too few.').test('divisibleByTwo', 'For this binding method the number of pages must be in multiples of 2 pages. Please feel free to call if you have any questions: 714-993-4800.', (value) => value % 2 === 0);
                    this.schemaObject['OptionbindingOther'] = Yup.string().nullable().notRequired();
                    this.schemaObject['BindingOption'] = Yup.string().nullable().required('Binding Option is required.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                const div = document.getElementById("myDiv");
                div.style.display = "none";
                //alert("hhhh");
            },
            CoverOnChange() {
                if (this.bookletdata.Cover == "Heavier cover") {
                    this.schemaObject['Cover'] = Yup.string().nullable().notRequired();
                    this.schemaObject['CoverStock'] = Yup.string().nullable().required('Cover Stock is required.');
                    this.schemaObject['CoverPaperWeight'] = Yup.string().nullable().required('Cover Paper Weight is required.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                else {
                    this.schemaObject['CoverStock'] = Yup.string().nullable().notRequired();
                    this.schemaObject['CoverPaperWeight'] = Yup.string().nullable().notRequired();
                    this.schemaObject['Cover'] = Yup.string().nullable().required('Cover Stock is required.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
            },
            CoverStockChange() {
                this.hidErrorMessage();
                this.bookletdata.CoverStockOther = '';
                if (this.bookletdata.CoverStock == "StockOther") {
                    this.schemaObject['CoverStock'] = Yup.string().nullable().notRequired();
                    this.schemaObject['CoverStockOther'] = Yup.string().nullable().required('Cover Stock is required.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                else {
                    this.schemaObject['CoverStockOther'] = Yup.string().nullable().notRequired();
                    this.schemaObject['CoverStock'] = Yup.string().nullable().required('Cover Stock is required.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
            },
            CoverPaperOnChange() {
                this.hidErrorMessage();
                this.bookletdata.CoverPaperWeightother = '';
                if (this.bookletdata.CoverPaperWeight == "CoverPaperOther") {
                    this.schemaObject['CoverPaperWeight'] = Yup.string().nullable().notRequired();
                    this.schemaObject['CoverPaperWeightother'] = Yup.number().typeError('Cover Paper Weight is required.').min(1, 'Minimum Cover Paper Weight is 1 lb')
                        .max(500, 'Maximum Cover Paper Weight is 500 lb');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
                else {
                    this.schemaObject['CoverPaperWeightother'] = Yup.string().nullable().notRequired();
                    this.schemaObject['CoverPaperWeight'] = Yup.string().nullable().required('Cover Paper Weight is required.');
                    this.schema = Yup.object().shape(this.schemaObject);
                }
            },
            validatePhoneNumber() {
                if (this.bookletdata.phoneNumber == '(___) ___-____') {
                    this.schemaObject['phone'] = Yup.string().notRequired();
                    this.schema = Yup.object().shape(this.schemaObject);
                    return
                }
                else if (!this.bookletdata.phoneNumber || this.bookletdata.phoneNumber.includes("_")) {
                    this.schemaObject['phoneNumber'] = Yup.string()
                        .nullable()
                        .required('Phone number is required.')
                        .matches(/^\d{10}$/, 'Phone number should be of 10 digits.')
                } else {
                    this.schemaObject['phoneNumber'] = Yup.string().notRequired();
                }
                this.schema = Yup.object().shape(this.schemaObject);

            },
        }
    }
</script>
<style scoped>
</style>